import { render, staticRenderFns } from "./DocumentosPropostaSection.vue?vue&type=template&id=60184a2b&"
import script from "./DocumentosPropostaSection.vue?vue&type=script&lang=js&"
export * from "./DocumentosPropostaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports